import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'zh' : import.meta.env.VITE_APP_LANG);

export const getDevToken = () =>
  `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc2NTg3NzY1MjQ5NCwiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTA2MjQ5In0.8F6_d1xA6gmyfLSCT0Q8sbpNzvrUlpNFqos9UtaoU8NkPMq29UcRGPjzO3y4pfhsK7iKwdYA-zEoVmJls_V__A`;

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
